import { Button, ButtonGroup, HorizontalScroll } from '@vkontakte/vkui';
import classNames from 'clsx';
import React, { memo } from 'react';
import { aiPhotoGenerationSuggestion } from 'reactApp/appHelpers/featuresHelpers/features/aiPhotoGeneration';

import styles from './AiPhotoGenerationSuggestions.css';

interface IProps {
    onSuggestionClick: (suggest: string) => void;
}

export const AiPhotoGenerationSuggestions = memo(({ onSuggestionClick }: IProps) => {
    return (
        <div className={styles.suggestions}>
            <HorizontalScroll scrollOnAnyWheel showArrows={false} data-test-id="suggestions">
                <ButtonGroup mode={'horizontal'}>
                    {aiPhotoGenerationSuggestion.map((suggest, index) => (
                        <Button
                            key={`suggest-${index}`}
                            size="m"
                            appearance="overlay"
                            mode="secondary"
                            data-test-id="suggestion"
                            data-suggestion-id={`suggest-${index}`}
                            className={classNames(styles.suggest, {
                                [styles.suggestFirst]: index === 0,
                            })}
                            onClick={() => {
                                onSuggestionClick(suggest);
                            }}
                        >
                            {suggest}
                        </Button>
                    ))}
                    <div className={styles.suggestLast} />
                </ButtonGroup>
            </HorizontalScroll>
        </div>
    );
});

AiPhotoGenerationSuggestions.displayName = 'AiPhotoGenerationSuggestions';
